import { combineReducers } from 'redux';

import { customerReducer as customerPage } from './../api/customer/customerReducer';
import { propertyReducer as propertyPage } from './../api/property/propertyReducer';
import { bookingReducer as bookingPage } from './../api/booking/bookingReducer';
import { cityReducer as cityPage } from '../api/cityes/cityesReducer';
import { listPropertyReducer as listPropertyPage } from '../api/listing-property/list-propertyReducer';
import { contactUsReducer as contactUsPage } from '../api/contact-us/contact-usReducer';
import { tagReducer as tagPage } from '../api/tag/tagReducer';
import { pageReducer as pagePage } from '../api/pages/pageReducer';
import { faqReducer as faqPage } from '../api/faq/faqReducer';
import { careerReducer as careerPage } from '../api/career/careerReducer';
import { blogReducer as blogPage } from '../api/blog/blogReducer';
import { brandReducer as brandPage } from '../api/brand/brandReducer';
import { websiteAppearanceReducer as websiteAppearancePage } from '../api/websiteAppearance/websiteAppearanceReducer';

const appReducer = combineReducers({
    brandPage,
    propertyPage,
    customerPage,
    bookingPage,
    cityPage,
    listPropertyPage,
    contactUsPage,
    tagPage,
    pagePage,
    faqPage,
    careerPage,
    blogPage,
    websiteAppearancePage,
});

export default appReducer;
